"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { d: "M5.75 20V4C5.75 3.86193 5.86193 3.75 6 3.75H12.6893L18.25 9.31066V20C18.25 20.1381 18.1381 20.25 18 20.25H6C5.86193 20.25 5.75 20.1381 5.75 20Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" }));
